const BLANK_PLACEMENT_FEE_ITEM = {
  description: null,
  salaryPeriod: "Monthly",
  rate1: null,
  rateType1: "Money",
  fixedRateType1: true,
  rate2: null,
  rateType2: "Percentage",
  fixedRateType2: true,
  determinant: "of annual salary based on 13 months salary",
  guaranteePeriodInMonths: null,
}

const BLANK_PAYROLL_PLACEMENT_FEE_ITEM = {
  description: null,
  salaryPeriod: "Monthly",
  rate1: null,
  rateType1: "Money",
  fixedRateType1: true,
  rate2: null,
  rateType2: "Percentage",
  fixedRateType2: true,
  guaranteePeriodInMonths: null,
}

const BLANK_PAYROLL_FEE_ITEM = {
  itemName: "Payroll Fee",
  description: null,
  rate1: null,
  rate2: null,
  rateType1: "Money",
  rateType2: "Percentage",
  fixedRateType1: true,
  fixedRateType2: true,
  determinant1: "Fixed Amount",
  determinant2: null,
  billingCycle: "Monthly",
  fixedBillingCycle: true,
  placementType: null,
}

const BLANK_PAYROLL_STATUTORY_ITEM = {
  itemName: null,
  description: null,
  rate: "In accordance to the prevailing rate",
  determinant: null,
  fixedBillingCycle: true,
  billingCycle: null,
  placementType: null,
}

const BLANK_PAYROLL_MISCELLANEOUS_ITEM = {
  itemName: null,
  description: null,
  rate: null,
  determinant: null,
  billingCycle: null,
  placementType: null,
}

const BLANK_WORK_PASS_RELATED_CHARGES_ITEM = {
  itemName: null,
  description: null,
  rate: null,
  determinant: null,
  billingCycle: null,
  placementType: null,
}

const BLANK_INSURANCE_ITEM = {
  itemName: null,
  description: null,
  rate: null,
  determinant: null,
  billingCycle: null,
  placementType: null,
}

const BLANK_TERMS_ITEM = {
  contractPeriodComplete: null,
  conversionRate: null,
  determinant: null,
  placementType: "AC - Own Sourced",
  fixedPlacementType: true,
}

export {
  BLANK_PLACEMENT_FEE_ITEM,
  BLANK_PAYROLL_PLACEMENT_FEE_ITEM,
  BLANK_PAYROLL_MISCELLANEOUS_ITEM,
  BLANK_WORK_PASS_RELATED_CHARGES_ITEM,
  BLANK_PAYROLL_FEE_ITEM,
  BLANK_PAYROLL_STATUTORY_ITEM,
  BLANK_INSURANCE_ITEM,
  BLANK_TERMS_ITEM,
}
